import React, { useEffect, useState } from "react";
import {
  FlatList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Pressable,
} from "react-native";
import { LeftView } from "../Chat/CListItem";
import { color_1E1E1E, color_F1F1F1, white } from "../../assets/style/colors";
import { ListEmpty } from "../../components/ListEmpty";
import { blackList } from "../../net/service";
import { getUserName } from "../Chat/chat-helper";
import { Str_BlackManager } from "../../language/string_res";
import { getAvatarByUser } from "../../utils/utils";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";
import { useWebNavigation } from "../../utils/WebNavigationHook";
import { MainNavProps } from "../navigation/main/MainParamList";
import { useIsFocused } from "@react-navigation/native";
import * as ImSdk from "../../../imsdk/api";
import globalEventBus from "../../utils/EventBus";

export const BlackList = ({ navigation }: MainNavProps<"BlackList">) => {
  const [section, setSection] = useState<any[]>([]);
  const webNavigate = useWebNavigation();
  const isFocused = useIsFocused();
  const im = ImSdk.getInstance();

  const fetchBlackList = () => {
    console.log("开始获取黑名单列表");
    blackList()
      .then((res) => {
        console.log("获取黑名单列表成功:", res);
        if (res.data && res.data.users) {
          console.log("黑名单用户列表:", res.data.users);
          setSection(res.data.users);
        } else {
          console.log("黑名单列表为空");
          setSection([]);
        }
      })
      .catch((error) => {
        console.error("获取黑名单失败:", error);
        setSection([]);
      });
  };

  useEffect(() => {
    if (isFocused) {
      fetchBlackList();
    }
  }, [isFocused]);

  // 监听黑名单状态变化事件
  useEffect(() => {
    const handleUserBlack = (data: any) => {
      console.log("收到 user_black 事件:", data);
      // 当黑名单状态变化时，重新获取黑名单列表
      fetchBlackList();
    };

    const handleBlackListUpdate = () => {
      console.log("收到 BlackList_Update 事件");
      fetchBlackList();
    };

    // 监听来自 imsdk 的黑名单变化事件
    im.on("user_black", handleUserBlack);
    // 监听来自 ContactInfo 的手动触发事件
    globalEventBus.on("BlackList_Update", handleBlackListUpdate);

    console.log("黑名单页面事件监听器已添加");

    return () => {
      // 清理事件监听器
      im.off("user_black", handleUserBlack);
      globalEventBus.off("BlackList_Update", handleBlackListUpdate);
      console.log("黑名单页面事件监听器已移除");
    };
  }, []);

  const onClick = (item: any) => {
    webNavigate("ContactInfoModeal", { current: item, type: "FRIEND", fromBlackList: true });
  };

  const renderItem = ({ item }: { item: any }) => {
    return (
      <TouchableOpacity onPress={() => onClick(item)} activeOpacity={1}>
        <View style={styles.item}>
          <LeftView left={getAvatarByUser(item)} size={50} />
          <Text style={styles.itemText}>{getUserName(item)}</Text>
          <View style={styles.itemLine} />
        </View>
      </TouchableOpacity>
    );
  };
  return (
    <ScreenCloseModal>
      <FlatList
        style={styles.list}
        contentContainerStyle={
          !section || section.length === 0 ? styles.emptyContainer : undefined
        }
        data={section || []}
        keyExtractor={(item) => item.uid.toString()}
        renderItem={renderItem}
        ListEmptyComponent={<ListEmpty />}
      />
    </ScreenCloseModal>
  );
};

const styles = StyleSheet.create({
  list: {
    flex: 1,
    marginHorizontal: 10,
    marginTop: 18,
  },
  emptyContainer: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 60,
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: white,
    borderRadius: 8,
    marginBottom: 8,
    minHeight: 60,
  },
  itemText: {
    flex: 1,
    fontSize: 16,
    color: "#000000",
    fontWeight: "500",
    fontFamily: "",
    marginLeft: 12,
  },
  itemLine: {
    position: "absolute",
    bottom: 0,
    start: 70,
    height: 1,
    end: 16,
    backgroundColor: color_F1F1F1,
  },
});
